module.exports = __webpack_public_path__ + "dist/assets/img/9.fc9330c2.svg";